module.exports = require("deep-extend");


//////////////////
// WEBPACK FOOTER
// external "deep-extend"
// module id = 271
// module chunks = 0